<div class="filters-applied">
  <div class="ui label" *ngIf="selectedFilters.length" (click)="resetAllFilters()">
    Clear filters <i class="delete icon"></i>
  </div>
  <div class="ui teal label" *ngIf="searchTerm" (click)="clearSearch()">
    Search: {{ searchTerm }} <i class="delete icon"></i>
  </div>
  <div class="ui blue label" *ngFor="let filter of selectedFilters" (click)="removeFilter(filter)">
    {{ filter }} <i class="delete icon"></i>
  </div>
</div>

<div class="ui inverted padded segment filters-container" [suiTransition]="transitionController">
  <i class="i large inverted chevron up link icon" (click)="this.toggle()"></i>
  <div class="ui small secondary inverted menu" *ngFor="let filterCategory of filterCategories">
    <div class="header item inverted">
      {{ filterCategory.header }}
    </div>
    <a class="ui grey item" *ngFor="let filter of filterCategory.filters" (click)="toggleFilter(filter)" [class.active]="selectedFilters.includes(filter)">
      {{ filter }}
    </a>
  </div>
</div>
